import { Component, Vue } from 'nuxt-property-decorator'
import meta from '@/helpers/meta'

interface Page {
  titolo: string
  contenuto: string
  image?: string | null
  slug: string
}

@Component
export default class SeoMetaComponent extends Vue {
  public seoMeta: any = {}

  public head() {
    return this.seoMeta
  }

  public loadMeta(data: Page | null) {
    let image = ''

    if (data?.image) {
      image = data?.image
    } else {
      image = this.$config.siteUrl + '/img/logo.png'
    }

    if (data) {
      this.seoMeta = meta(
        data?.titolo,
        data?.contenuto,
        image,
        this.$config.siteUrl + data?.slug
      )
    }
  }
}
